import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgShopAssistant = function SvgShopAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 15.1c3.728 0 6.75-3.212 6.75-7.175C18.75 3.962 15.728.75 12 .75S5.25 3.962 5.25 7.925c0 3.963 3.022 7.175 6.75 7.175Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.633 3.573A10.831 10.831 0 0 0 14.25 6.75c1.452 0 2.888-.298 4.221-.874"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.274 19.916-5.2-2.422a1.14 1.14 0 0 0-1.652.952v3.738a1.147 1.147 0 0 0 1.775.885l5.077-3.153Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.274 19.916 4.454-2.422a.984.984 0 0 1 1.416.951v3.739a.978.978 0 0 1-1.521.885l-4.35-3.153Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.121 11.121a3 3 0 0 1-4.242 0"
  })));
};

export { SvgShopAssistant as default };
//# sourceMappingURL=shop-assistant.svg.js.map
